import { Profile } from "@app/pages/ProfilePage";
import { ContextModalProps } from "@mantine/modals";

type ProfileModalInnerProps = {
	initialTab?: string | null;
};

export const ProfileModal = ({ id, context, innerProps }: ContextModalProps<ProfileModalInnerProps>) => {
	const { initialTab } = innerProps || {};
	return <Profile />;
};

export default ProfileModal;
